var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Typography } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { DetailsIcon } from './Icons';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  text-align: center;\n\n  .MuiTypography-root {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 200px;\n  }\n"], ["\n  display: block;\n  text-align: center;\n\n  .MuiTypography-root {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 200px;\n  }\n"])));
var DownloadIconWithText = function (_a) {
    var title = _a.title;
    return (React.createElement(Wrapper, { title: title },
        React.createElement(DetailsIcon, { sx: { fontSize: 96 } }),
        React.createElement(Typography, { component: "div" }, title)));
};
export default DownloadIconWithText;
var templateObject_1;
